import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Layout from '@/views/layout/layout.vue'

Vue.use(VueRouter)

export const constantRoutes: RouteConfig[] = [{
  path: '/login',
  component: () => import('@/views/login/index.vue'),
  meta: {
    hidden: true,
  }
}, {
  path: '/',
  component: Layout,
  redirect: '/home/index',
  name: '主页',
  meta: {
    hidden: true
  }
}]

export const asyncRoutes: RouteConfig[] = [
  {
    path: '/home',
    component: Layout,
    children: [{
      path: 'index',
      name: 'Home',
      component: () => import('@/views/home/index.vue'),
      meta: {
        title: '首页',
        icon: 'home',
        type: 'single'
      }
    }]
  }, {
    path: '/product',
    component: Layout,
    meta: {
      title: '商品管理',
      icon: 'product'
    },
    children: [{
      path: 'list',
      name: 'Product_List',
      component: () => import('@/views/product/list.vue'),
      meta: {
        title: '商品库',
        keepAlive: true
      }
    },{
      path: 'checkdetail',
      name: 'checkdetail',
      component: () => import('@/views/product/checkdetail.vue'),
      meta: {
        title: '商品审核信息',
        hidden: true,
      }
    }, {
      path: 'sales',
      name: 'Product_Sales',
      component: () => import('@/views/product/sales.vue'),
      meta: {
        title: '商品销量统计'
      }
    },{
      path: 'rank',
      name: 'Product_Rank',
      component: () => import('@/views/product/rank.vue'),
      meta: {
        title: '销售排行',
        hidden: true
      }
    },{
      path: 'product-detail',
      name: 'Product_Detail',
      component: () => import('@/views/product/product_detail.vue'),
      meta: {
        title: '商品信息',
        hidden: true,
        keepAlive: true
      }
    },{
      path: 'settleFreight',
      name: 'settleFreight',
      component: () => import('@/views/product/settleFreight/index.vue'),
      meta: {
        title: '设置供货价',
        hidden: true
      }
    },
    {
      path: 'auditScheduleShop',
      name: 'auditScheduleShop',
      component: () => import('@/views/product/auditScheduleShop/index.vue'),
      meta: {
        title: '排期商品'
      }
    },
    {
      path: 'auditScheduleShopDetails',
      name: 'auditScheduleShopDetails',
      component: () => import('@/views/product/auditScheduleShop/shopDetails.vue'),
      meta: {
        title: '商品信息',
        hidden: true,
      }
    },
    ]
  }, {
    path: '/order',
    component: Layout,
    meta: {
      title: '订单管理',
      icon: 'order'
    },
    children: [{
      path: 'list',
      name: 'Order_List',
      component: () => import('@/views/order/list.vue'),
      meta: {
        title: '销售订单',
        keepAlive: true
      }
    }, {
      path: 'order-detail',
      name: 'Order_Detail',
      component: () => import('@/views/order/detail.vue'),
      meta: {
        title: '查看详情',
        hidden: true
      }
    }, {
      path: 'order-result',
      name: 'Order_Result',
      component: () => import('@/views/order/result.vue'),
      meta: {
        title: '发货结果',
        hidden: true
      }
    }, {
      path: 'scatteredorder',
      name: 'scatteredorder',
      component: () => import('@/views/order/scatteredorder.vue'),
      meta: {
        title: '散单物流',
      }
    },
    {
      path: 'shopSettlement',
      name: 'shopSettlement',
      component: () => import('@/views/order/shopSettlement/index.vue'),
      meta: {
        title: '商品结算',
      }
    },]
  },{
    path: '/aftersales',
    component: Layout,
    meta: {
      title: '售后管理',
      icon: 'aftersales'
    },
    children:[
      {
        path: 'after-list',
        name: 'After_List',
        component: () => import('@/views/aftersales/order.vue'),
        meta: {
          title: '售后单管理',
          // hidden: true
          keepAlive: true
        }
      }, {
        path: '/aftersales/detail',
        name: 'After_Detail',
        component: () => import('@/views/aftersales/detail.vue'),
        meta: {
          title: '售后订单详情',
          hidden: true
        }
      },
    ]
  },
  {
    path: '/logistics',
    component: Layout,
    meta: {
      title: '物流管理',
      icon: 'logistics'
    },
    children: [ 
      {
        path: 'desc',
        name: 'Desc_List',
        component: () => import('@/views/logistics/desc_list.vue'),
        meta: {
          title: '物流模板'
        }
      }, {
        path: 'detail',
        name: 'Template_Detail',
        component: () => import('@/views/logistics/detail.vue'),
        meta: {
          title: '物流模版',
          hidden: true
        }
      }, {
        path: 'refund',
        name: 'Refund_Address',
        component: () => import('@/views/logistics/refund.vue'),
        meta: {
          title: '退货地址'
        }
      }, 
      // {
      //   path: 'settleTemplate',
      //   name: 'settleTemplate',
      //   component: () => import('@/views/logistics/settleTemplate/index.vue'),
      //   meta: {
      //     title: '物流结算模板',
      //     keepAlive: true
      //   }
      // },
      {
        path: 'settleTemplatedetail',
        name: 'settleTemplatedetail',
        component: () => import('@/views/logistics/settleTemplate/detail.vue'),
        meta: {
          title: '物流结算规则',
          hidden: true
        }
      },{
        path: 'settleTemplaterecord',
        name: 'settleTemplaterecord',
        component: () => import('@/views/logistics/settleTemplate/record.vue'),
        meta: {
          title: '修改记录',
          hidden: true
        }
      },
    ]
  }, {
    path: '/finance',
    component: Layout,
    meta: {
      title: '财务管理',
      icon: 'message'
    },
    children:[
      {
        path: 'shopsettle',
        name: 'shopsettle',
        component: () => import('@/views/finance/shopsettle/index.vue'),
        meta: {
          title: '商品结算管理',
          keepAlive:true
        }
      },
      {
        path: 'settleDetails',
        name: 'settleDetails',
        component: () => import('@/views/finance/shopsettle/settleDetails.vue'),
        meta: {
          title: '商品结算管理',
          hidden:true
        }
      },
      {
        path: 'orderDetails',
        name: 'orderDetails',
        component: () => import('@/views/finance/shopsettle/orderDetails.vue'),
        meta: {
          title: '订单明细',
          hidden:true
        }
      },
      {
        path: 'aftersaleDetails',
        name: 'aftersaleDetails',
        component: () => import('@/views/finance/shopsettle/aftersaleDetails.vue'),
        meta: {
          title: '售后明细',
          hidden:true
        }
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/views/finance/shopsettle/account.vue'),
        meta: {
          title: '结算账户',
          hidden:true
        }
      },
      {
        path: 'invoice',
        name: 'invoice',
        component: () => import('@/views/finance/invoice/index.vue'),
        meta: {
          title: '发票管理',
        }
      },
      {
        path: 'waitInvoiceOrder',
        name: 'waitInvoiceOrder',
        component: () => import('@/views/finance/waitInvoiceOrder/index.vue'),
        meta: {
          title: '待开票订单',
        }
      },
      {
        path: 'waitInvoiceOrderDetails',
        name: 'waitInvoiceOrderDetails',
        component: () => import('@/views/finance/waitInvoiceOrder/details.vue'),
        meta: {
          title: '待开票订单',
          hidden:true
        }
      },
    ]
  },{
    path: '/auth',
    component: Layout,
    meta: {
      title: '其他',
      icon: 'other'
    },
    children: [{
      path: 'roles',
      name: 'Auth_Roles',
      component: () => import('@/views/auth/roles.vue'),
      meta: {
        title: '个人中心'
      }
    }, {
      path: 'safe',
      name: 'Account_Safe',
      component: () => import('@/views/auth/safe.vue'),
      meta: {
        title: '账号安全'
      }
    }]
  }
  // , {
  //   path: '/financial',
  //   component: Layout,
  //   meta: {
  //     title: '财务管理',
  //     icon: 'message'
  //   },
  //   children: [{
  //     path: 'general',
  //     name: 'Notice_List',
  //     component: () => import('@/views/financial/general/general.vue'),
  //     meta: {
  //       title: '财务概览',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'supplier-account',
  //     name: 'supplier_account',
  //     component: () => import('@/views/financial/general/supplier-account.vue'),
  //     meta: {
  //       title: '供应商账户',
  //       hidden: true // 控制左侧菜单展示or隐藏，是二级跳转页，不是首页
  //     }
  //   }, {
  //     path: 'routuan-account',
  //     name: 'routuan_account',
  //     component: () => import('@/views/financial/general/routuan-account.vue'),
  //     meta: {
  //       title: '拾物Zone账户',
  //       hidden: true // 控制左侧菜单展示or隐藏，是二级跳转页，不是首页
  //     }
  //   }, {
  //     path: 'supplier-detail',
  //     name: 'supplier_detail',
  //     component: () => import('@/views/financial/general/supplier-detail.vue'),
  //     meta: {
  //       title: '供应商详情',
  //       hidden: true // 控制左侧菜单展示or隐藏
  //     }
  //   }, {
  //     path: 'detail',
  //     name: 'Notice_Detail',
  //     component: () => import('@/views/financial/check-account.vue'),
  //     meta: {
  //       title: '财务对账',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'check-account-detail',
  //     name: 'check_account_detail',
  //     component: () => import('@/views/financial/check-account-detail.vue'),
  //     meta: {
  //       title: '财务对账详情',
  //       hidden: true
  //     }
  //   }, {
  //     path: 'income-detail',
  //     name: 'income_detail',
  //     component: () => import('@/views/financial/income-detail.vue'),
  //     meta: {
  //       title: '收入明细',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'refund-detail',
  //     name: 'refund_detail',
  //     component: () => import('@/views/financial/refund-detail.vue'),
  //     meta: {
  //       title: '退款明细',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'order-detail',
  //     name: 'order_detail',
  //     component: () => import('@/views/financial/order-detail.vue'),
  //     meta: {
  //       title: '订单明细',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'order-detail-back',
  //     name: 'order_detail_back',
  //     component: () => import('@/views/financial/order-detail-back.vue'),
  //     meta: {
  //       title: '订单财务往来',
  //       hidden: true
  //     }
  //   },{
  //     path: 'platform-detail',
  //     name: 'platform_detail',
  //     component: () => import('@/views/financial/platform-detail.vue'),
  //     meta: {
  //       title: '平台提现明细',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'supplier-computedetail',
  //     name: 'supplier_computedetail',
  //     component: () => import('@/views/financial/supplier-computedetail.vue'),
  //     meta: {
  //       title: '供应商结算明细',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'supplier-computedetail2',
  //     name: 'supplier_computedetail2',
  //     component: () => import('@/views/financial/supplier-computedetail2.vue'),
  //     meta: {
  //       title: '供应商结算明细查看',
  //       hidden: true
  //     }
  //   }, {
  //     path: 'supplier-table',
  //     name: 'supplier_table',
  //     component: () => import('@/views/financial/supplier-table.vue'),
  //     meta: {
  //       title: '供应商已结算明细查看',
  //       hidden: true
  //     }
  //   }, {
  //     path: 'account-manage',
  //     name: 'account_manage',
  //     component: () => import('@/views/financial/account-manage.vue'),
  //     meta: {
  //       title: '账户管理',
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'platform-detail-table',
  //     name: 'platform_detail_table',
  //     component: () => import('@/views/financial/platform-detail-table.vue'),
  //     meta: {
  //       title: '平台提现管理',
  //       hidden: true
  //     }
  //   }, {
  //     path: 'account-manage-table',
  //     name: 'account_manage_table',
  //     component: () => import('@/views/financial/account-manage-table.vue'),
  //     meta: {
  //       title: '供应商账户详情',
  //       hidden: true
  //     }
  //   }]
  // },
]

const createRouter = () => new VueRouter({
  // 切换页面保存滚动条定位
  scrollBehavior: (to: any, from: any, savedPosition: any) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: constantRoutes
})

const router = createRouter();
export default router;
